import React, { useState } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import ChatWidget from './ChatWidget';
import DemoModal from './DemoModal';

const Layout = ({ children }) => {
  const [chatDemoOpen, setChatDemoOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">{children}</main>
      <Footer />
      <ChatWidget onOpenDemoModal={() => setChatDemoOpen(true)} />
      <DemoModal open={chatDemoOpen} onOpenChange={setChatDemoOpen} />
    </div>
  );
};

export default Layout;
